module.exports = flarum.core.compat['components/SettingsModal'];